function CIDCardGrid({ children }) {
  return (
    <div className="cid-card-grid">
      {children}
    </div>
  );
}

export default CIDCardGrid;
